<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/fgk-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>太保建筑行业灵活用工保（限广东企业）</h2>
					<div>行业超低价 | 中国太平洋承保 | 全线上操作</div>
					<p>
						① 行业首创新市民专属保障产品方案，更贴心、更全面
						<br />
						② 覆盖定制新市民群体职业风险特点，更适合、更可靠
						<br />
						③ 符合行业灵活用工等新就业形态人员，更安心、更省心
						<br />
						④ 3人起保，最高保额120万，社保用药、误工费、猝死有保障
					</p>
					<div>
						<el-button size="medium" type="warning" @click.native="handleInsure(0)">立即投保</el-button>
					</div>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="handleDownLoad">
						下载新市民保职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="plan"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
					<el-row style="margin-bottom: 10px; margin-top: 20px">
						<span style="font-weight: bold">批增规则</span>
					</el-row>
					<avue-crud ref="add" :data="dataAddFeeRate" :option="optionAddFeeRate"></avue-crud>
					<!-- <el-row style="font-weight: 500; color:Red">
                        <span style="">投保钢结构（钢骨结构）、机械设备拆除工种，对应保费上浮20%，且工种名称不可批改。</span>
          </el-row>-->
				</el-card>
				<el-card header="短期单" style="font-weight: bold">
					<avue-crud
						ref="premium"
						:data="dataPremium"
						:option="optionPremium"
						:span-method="spanMethodPremium"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药范围100%赔付，伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>

									<span
										v-if="
											qa.question === '广东新市民保（建筑行业）的保险责任是什么？' ||
											qa.question === '是否可保承揽关系，什么是承揽关系？'
										"
										style="font-weight: bold; color: red">
										{{ qa.question }}
									</span>
									<span v-else style="font-weight: bold">
										{{ qa.question }}
									</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span v-if="qa.question === '是否可保承揽关系，什么是承揽关系？'">{{ qa.anwser }}</span>
									<span v-else>{{ qa.anwser }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1. 本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，
							<span class="red-bold">承保区域为广东省范围内、仅限承保营业执照注册地址在广东的企业和组织</span>
							<br />
							3、新市民是指：指因本人创业就业、子女上学、投靠子女等原因来到城镇常住,未获得当地户籍或获得当地户籍不满三年的各类群体,包括但不限于进城务工人员、新就业大中专毕业生等。
							<br />
							4、新就业形态人员是指：是指以非全日制、临时性、季节性、弹性工作等灵活多样形式实现就业的人员。
							<br />
							5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
							<span class="red-bold">
								故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
							</span>
							因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							<br />
							7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							8、本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							9、本保险由博维保险经纪有限公司面向
							<span class="red-bold">广东省内销售并提供服务</span>
							，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							<br />
							10、
							<span class="red-bold">
								如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							</span>
							<br />
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<p style="line-height: 32px">
							<span style="font-weight: bold">1、保障期限：</span>
							<br />
							<span>只允许投保1、3、6、12个月。</span>
							<br />
							<span style="font-weight: bold">2、特约：</span>
							<br />
							（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
							<span class="red-bold">超过72小时</span>
							才报案，则保险人对按保单约定的应承担的保险责任，
							<span class="red-bold">免赔50%</span>
							。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							<br />
							（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
							<br />
							（3）
							<span class="red-bold">本保单可加人（不足1个月的按1个月收费），不可减人</span>
							。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。
							<br />
							（4）如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							<br />
							（5）本保单仅承保建筑相关行业，1-3类职业不保高空作业，4-6类职业可保高空作业。
							<br />
							（6）
							<span class="red-bold">
								本保单拒绝承保职业：地下作业、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、钢结构、钢骨结构、涉及火药/炸药/爆破的相关工作和建筑拆除。
							</span>
							<br />
							（7）被保险人从业人员遭受伤害时，
							<span class="red-bold">
								实际从事的工作（不属于拒绝承保职业）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如属于拒绝承保职业，保险人不承担任何赔偿责任。
							</span>
							<br />
							（8）在工作时间和工作岗位，
							<span class="red-bold">突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），
							<span class="red-bold">保险人承担赔偿责任，赔款=每人身故赔偿限额*20%</span>
							。
							<br />
							（9）如被保险人从业人员遭遇保险事故导致身故，保险人根据《民法典》及《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》等相关法律法规计算从业人员的赔偿金额。
							<br />
							（10）如被保险人从业人员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							<br />
							（11）按伤残鉴定机构出具的伤残程度鉴定书，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例50%，七级伤残给付比例40%，
							<span class="red-bold">八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。</span>
							<br />
							（12）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。
							<br />
							（13）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
							<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付</span>
							。
							<br />
							（14）被保险人从业人员
							<span class="red-bold">无安全带或者无特种作业操作证（包括但不限高处作业证）</span>
							，保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
							<span class="red-bold">免赔25%</span>
							。
							<br />
							（15）本保单
							<span class="red-bold">指定就诊医院为大陆境内二级及以上公立医院</span>
							。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
							<br />
							（16）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							<br />
							（17）
							<span class="red-bold">
								本保单仅承保施工地址在广东省内的工程项目。如施工地址在广东省外，保险人不承担任何赔偿责任。
							</span>
							<br />
							（18）本保单承保法律费用责任，
							<span class="red-bold">累计赔偿限额为RMB10万元，</span>
							每次事故赔偿限额为RMB10万元。
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {optionAddFeeRate, optionBenefit, optionPlan, optionPremiumXsm} from '@/const/crud/insurance/productDetail'
import {getProductPrice} from '@/api/insurance/product'
import {handleDownCategoryFile} from '@/util/util'
import {currentYYYYmmdd} from '@/util/date'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlan,
			optionPremium: optionPremiumXsm,
			optionBenefit: optionBenefit,
			optionAddFeeRate: optionAddFeeRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '30万/人',
					plan2: '50万/人',
					plan3: '80万/人',
					plan4: '100万/人',
					plan5: '120万/人',
				},
				{
					insuredItem: '医疗费用',
					plan1: '3万/人',
					plan2: '5万/人',
					plan3: '8万/人',
					plan4: '10万/人',
					plan5: '20万/人',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天/人，每次90天，累计180天为限（仅承担住院期间与出院后建休误工时间）',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万/企业',
				},
				{
					insuredItem: '1-3类职业',
				},
				{
					insuredItem: '4-5类职业',
				},
				{
					insuredItem: '6类职业',
				},
			],
			priceList1: [60, 90, 120, 150, 180],
			priceList2: [90, 135, 195, 225, 285],
			priceList3: [126, 180, 306, 324, 330],

			coverageMap: new Map([
				[30, 1],
				[50, 2],
				[80, 3],
				[100, 4],
				[120, 5],
			]),
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '10%',
					level8: '20%',
					level7: '40%',
					level6: '50%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataAddFeeRate: [
				{
					category: '1-3类职业',
					month1: '15%',
					month2: '20%',
					month3: '30%',
					month4: '40%',
					month5: '50%',
					month6: '60%',
					month7: '70%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
				},
				{
					category: '4-5类职业',
					month1: '15%',
					month2: '20%',
					month3: '30%',
					month4: '40%',
					month5: '50%',
					month6: '60%',
					month7: '70%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
				},
				{
					category: '6类职业',
					month1: '15%',
					month2: '20%',
					month3: '30%',
					month4: '40%',
					month5: '50%',
					month6: '60%',
					month7: '70%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
				},
			],
			dataPremium: [
				{
					insuredTerm: '1个月',
					term: 1,
				},
				{
					insuredTerm: '3个月',
					term: 3,
				},
				{
					insuredTerm: '6个月',
					term: 6,
				},
			],
			dataPremiumRestrict: [
				{
					insuredTerm: '投保收费规则',
				},
				{
					insuredTerm: '1个月',
					term: 1,
				},
				{
					insuredTerm: '3个月',
					term: 3,
				},
				{
					insuredTerm: '6个月',
					term: 6,
				},
				{
					insuredTerm: '批增收费规则',
				},
				{
					insuredTerm: '2个月',
					term: 2,
				},
				{
					insuredTerm: '4个月',
					term: 4,
				},
				{
					insuredTerm: '5个月',
					term: 5,
				},
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					anwser: '本产品由世界500强的中国太平洋财产保险股份有限公司承保。',
				},
				{
					question: '广东新市民保（建筑行业）的保险责任是什么？',
					anwser:
						'在保险期间内，被保险人的从业人员在从事与被保险人业务有关的工作过程中遭受意外事故导致人身伤害的，对被保险人依照中华人民共和国法律（不含香港、澳门特别行政区和台湾地区法律，下同）应承担的经济赔偿责任，保险人按照保险单的约定负责赔偿。保险事故发生后，被保险人因保险事故被提起仲裁或者诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的法律费用（以下简称“法律费用”），保险人按照保险单的约定也负责赔偿。',
				},
				{
					question: '新市民是指哪些人群？',
					anwser:
						'指因本人创业就业、子女上学、投靠子女等原因来到城镇常住,未获得当地户籍或获得当地户籍不满三年的各类群体,包括但不限于进城务工人员、新就业大中专毕业生等。',
				},
				{
					question: '新就业形态是指什么？',
					anwser: '新就业形态人员是指：是指以非全日制、临时性、季节性、弹性工作等灵活多样形式实现就业的人员。',
				},
				{
					question: '哪些职业可保？',
					anwser:
						'本保单仅承保建筑相关行业，1-3类职业不保高空作业，4-6类职业可保高空作业。本产品可保障职业：电梯/升降梯安装维修、通信工程安装及维护（不含铁塔架设和拆除）、焊工、电力建设及检修、广告牌安装及维修及路灯安装、外墙清洗、玻璃幕墙安装及维修、建筑工程（仅限工业、民用建房工程以及装修）等。需根据实际工作职业选择对应类别。',
				},
				{
					question: '哪些职业不保？',
					anwser:
						'本保单拒绝承保职业：地下作业、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、钢结构、钢骨结构、涉及火药/炸药/爆破的相关工作和建筑拆除。',
				},
				{
					question: '如果从事高处作业，但是无安全带或者无特种作业操作证（比如高处作业证），保险公司是否拒赔？',
					anwser:
						'不会拒赔。被保险人雇员无安全带或者无特种作业操作证（包括但不限高处作业证），保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，免赔25%。',
				},
				{
					question: '什么是高处作业？',
					anwser:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”',
				},
				{
					question: '误工费怎么赔？',
					anwser:
						'按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅接受门诊治疗的，按本保单约定无误工费赔付。',
				},
				{
					question: '怎么投保？怎么支付？',
					anwser:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→支付保费→获取保单。目前支持微信、支付宝、银联支付。',
				},
				{
					question: '保单和发票怎么获取？',
					anwser: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
				{
					question: '保单如何查验真伪？',
					anwser: '可以通过拨打太平洋保险全国客服电话95500进行人工查询。',
				},
				{
					question: '从业人员变动怎么办？',
					anwser:
						'本产品可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。替换时，原4-5类职业人员只能替换为新的4-5类职业人员，原6类职业人员只能替换为新的6类职业人员。不分节假日，全天24小时，均可线上直接替换或新增人员。',
				},
				{
					question: '出险从业人员是否可替换出去？',
					anwser: '不可以。',
				},
				{
					question: '怎么理赔？多久收到赔款？',
					anwser:
						'出险后请拨打理赔专线400-180-1616报案→收集资料→提交审核→支付结案。理赔时效：万元以下资料齐全，1个工作日赔款到账；万元以上资料齐全，在保险双方达成一致意见后一般十个工作日赔款到账。',
				},
				{
					question: '是否可保承揽关系，什么是承揽关系？',
					anwser:
						'本保单承保承揽关系，但需提供从业人员从事与被保险人业务有关的工作证明。根据《中华人民共和国民法典》规定：承揽人按照定作人的要求完成工作，交付劳动成果，定作人给付报酬的权利义务关系，承揽人应当以自己的设备、技术和劳力完成主要工作，但当事人另有约定的除外。',
				},
			],
			isDownLoading: false,
		}
	},
	created() {
		this.init()
		this.onDealSubject()
		this.onDealShortSubject()
	},
	methods: {
		//处理保障项目
		onDealSubject() {
			let tempData6 = [920, 1320, 2240, 2380, '不销售']
			this.dataPlan.forEach((itemData, index) => {
				let {insuredItem} = itemData
				let tempData = []
				switch (index) {
					case 4:
						tempData = this.priceList1
						break
					case 5:
						tempData = this.priceList2
						break
					case 6:
						tempData = this.priceList3
						break
				}
				if (index < 4) {
					return
				}
				for (let i = 1; i < 6; i++) {
					if (index === 6) {
						itemData[`plan${i}`] = tempData6[i - 1] + (i === 5 ? '' : '元/人/年')
					} else {
						itemData[`plan${i}`] = (tempData[i - 1] * 6.6666666667).toFixed(0) + '元/人/年'
					}
				}
			})
		},
		onDealShortSubject() {
			let tempPlanLists = [30, 50, 80, 100, 120]
			this.dataPremium.forEach((itemData, index) => {
				let tempFeeRate = 1
				if (index === 1) {
					tempFeeRate = 2
				} else if (index === 2) {
					tempFeeRate = 4
				} else if (index === 3) {
					tempFeeRate = 6.666666667
				}
				for (let i = 0; i < tempPlanLists.length; i++) {
					let tempItem = tempPlanLists[i]
					itemData[`plan${tempItem}_1`] = (this.priceList1[i] * tempFeeRate).toFixed(0)
					itemData[`plan${tempItem}_2`] = (this.priceList2[i] * tempFeeRate).toFixed(0)
					itemData[`plan${tempItem}_3`] = i !== 4 ? (this.priceList3[i] * tempFeeRate).toFixed(0) : '不销售'
				}
			})
		},

		init() {
			let query = {
				pid: this.productId,
			}
			getProductPrice(query).then(({data: {data = [], code = -1}}) => {
				if (code !== 0 || data.length === 0) {
					this.$message.error('获取数据有误!')
					return
				}
				data.forEach((item) => {
					let config = JSON.parse(item.config.replace('\n', ''))
					// if (this.validatenull(item.rules)) {
					//     this.setPlanData(item.coverage, item.scope, item.shortFeeMaps)
					//     this.setAddFeeRate(item.scope, config.operateConfig.add.yearFeeRate)
					//     this.setPremiumData(item.coverage, item.scope, config.operateConfig.add.shortFee)
					// } else {
					//     this.setPremiumRestrictData(item.coverage, config.operateConfig.add.shortFee)
					// }
				})
			})
		},
		setAddFeeRate(scope, yearFees) {
			if (this.validatenull(yearFees)) {
				return
			}
			this.dataAddFeeRate.forEach((item) => {
				if (!this.validatenull(item.scope) && item.scope == scope) {
					for (var i = 1; i < 12; i++) {
						let prop = 'month' + i
						this.$set(item, prop, yearFees[i] + '%')
					}
				}
			})
		},
		setPlanData(coverage, scope, feeMap) {
			this.dataPlan.forEach((item) => {
				if (!this.validatenull(item.scope) && item.scope == scope) {
					let prop = 'plan' + this.coverageMap.get(coverage)
					let fee = feeMap[12]
					let value = !this.validatenull(fee) ? Math.round(fee / 100) + '元/年' : '不销售'
					this.$set(item, prop, value)
				}
			})
		},
		setPremiumData(coverage, scope, shortFee) {
			this.dataPremium.forEach((item) => {
				if (!this.validatenull(item.term)) {
					let prop = 'plan' + coverage + '_' + (scope - 8)
					this.$set(item, prop, Math.round(shortFee[item.term] / 100))
				}
			})
		},
		setPremiumRestrictData(coverage, shortFee) {
			this.dataPremiumRestrict.forEach((item) => {
				if (!this.validatenull(item.term)) {
					let prop = 'plan' + coverage
					this.$set(item, prop, Math.round(shortFee[item.term] / 100))
				}
			})
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 4 || rowIndex === 5 || rowIndex === 6) {
				if (columnIndex !== 0) {
					return {
						color: 'red',
						fontWeight: 'bold',
						fontSize: '16px',
					}
				}
			}
		},
		spanMethodPremium({row, column, rowIndex, columnIndex}) {
			// if (rowIndex === 4) {
			//     if (columnIndex === 0) {
			//         return [1, 11]
			//     }
			// }
		},
		spanMethodPremiumRestrict({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 6]
				}
			}
		},
		handleInsure(type) {
			this.$emit('insure', type)
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `xsm_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	font-weight: bold;
	color: red;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
